import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ViewManagerService } from '../../../../core/services/view-manager-service';
import { Esito } from '../../../models/esito';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Scadenza } from '../../../models/scadenza';
import { ScadenzaAuto } from '../../../models/scadenzario/scadenza-auto';
import { SezioneScadenze } from '../../../models/sezioni/sezione-scadenze';
import { MotivoScadenzaAuto } from '../../../models/tipologiche/motivo-scadenza-auto';
import { Priorita } from '../../../models/tipologiche/priorita';

@Component({
    moduleId: module.id.replace('/dist/', '/'),
    selector: 'div [esiti-mod-auto-add-scadenze-form]',
    templateUrl: 'esiti-mod-auto-add-scadenze-form.component.html',
    host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})
export class EsitiModAutoAddScadenzeFormComponent implements OnInit {

    motivoScadenzaOptions: MotivoScadenzaAuto[] = [];
    prioritaOptions: Priorita[] = [];

    esitoIns: Esito;
    fascicolo: FascicoloFull;

    numPag: number = 0;
    isDataInsAgosto: boolean = false;
    abbreviazTermini: boolean = false;
    sospFeriale: boolean = false;

    isLoadingPag2: boolean = false;
    listaScadenzeAuto: ScadenzaAuto[] = [];
    isLoadingInsScad: boolean = false;

    urlAddScadenza: string;
    idFascicolo: string;
    idSezioneScadenze: string;

    flgAttore: number = 1;
    idGrado: string = '';
    codiceTipoData: string = '';
    data: number = 0;
    tipoPratica: string;
    tipoFascicolo: string;

    @Output()
    onReturn: EventEmitter<SezioneScadenze> = new EventEmitter<SezioneScadenze>();


// NG-ONINIT
//----------
    constructor(
        private operationService: OperationsService,
        private viewManager: ViewManagerService,
        private helpers: HelpersService
    ){
        //super(operationService, campiForm, helpers);
    }


// NG-ONINIT
//----------
    ngOnInit() {
        //Recupera i motivi e le priorita' delle scadenze
        this.helpers.getMotiviScadenzaAutomatica().subscribe(response => this.motivoScadenzaOptions = response);
        this.helpers.getPrioritaScadenza().subscribe(response => this.prioritaOptions = response);
    }


// INIZIALIZZA   [Si attiva all'apertura del dialog]
//------------
    inizializza(esitoIns: Esito, url: string, idSezioneScadenze: string, fascicolo: FascicoloFull, tipoPratica: string, tipoFascicolo: string) {

        //Ottiene i dati utili
        this.urlAddScadenza = url;
        this.idFascicolo = fascicolo.id;
        this.idSezioneScadenze = idSezioneScadenze;
        this.fascicolo = fascicolo;

        //Inizializza tutte le variabili interne
        this.esitoIns = esitoIns;
        this.numPag = 1;
        this.isDataInsAgosto = false;
        this.abbreviazTermini = false;
        this.sospFeriale = false;
        this.isLoadingPag2 = false;
        this.listaScadenzeAuto = [];
        this.isLoadingInsScad = false;

        //Ottiene il grado del fascicolo (primo, secondo...)
        this.idGrado = fascicolo.grado.id;

        //Se l'id natura è 1 = Attore, altrimenti è = Convenuto
        if(fascicolo.natura.id == '1'){
            this.flgAttore = 1;
        }else{
            this.flgAttore = 0;
        }

        //Imposta il codice tipo data a seconda della data che è stata inserita
        let codiceTipoData;
        if(esitoIns.dataPubblicazione){
            codiceTipoData = 'PUB';
            this.data = esitoIns.dataPubblicazione;
        }
        else if(esitoIns.dataNotifica){
            codiceTipoData = 'NOT';
            this.data = esitoIns.dataNotifica;
        }
        this.codiceTipoData = codiceTipoData;
        this.tipoPratica = tipoPratica;
        this.tipoFascicolo = tipoFascicolo;

    }


// CALCOLA TERMINI      [Si attiva alla pressione del tasto calcola. Avanza alla pagina 2 del dialog e avvia la chiamata]
//----------------
    calcolaTermini(): void{
        this.numPag = 2;
        this.isLoadingPag2 = true;
        this.getScadenzeAutocalcolate();
    }


// GET SCADENZE AUTOCALCOLATE      [Ottiene la lista delle scadenze calcolate dal sistema secondo i parametri passati]
//---------------------------
    getScadenzeAutocalcolate(): void{

        const url = '/esitoScadenza/getScadenze';
        const data = this.data;
        const idTipoEsito = this.esitoIns.tipoEsito.id;
        const codiceTipoData = this.codiceTipoData;
        const idGrado = this.idGrado;
        const flagAbbreviato = this.abbreviazTermini? 1 : 0;
        const flagSospensioneTermini = this.sospFeriale? 1 : 0;
        const flagAttore = this.flgAttore;
        const tipoPratica =  this.tipoPratica;
        const tipoFascicolo = this.tipoFascicolo;

        this.operationService.scadenzarioEsitiGetScadenzeAutogenerate(url, data, idTipoEsito, codiceTipoData, idGrado, flagAbbreviato, flagSospensioneTermini, flagAttore, tipoPratica, tipoFascicolo)
            .subscribe(response => {
                this.listaScadenzeAuto = response;
                this.isLoadingPag2 = false;
            });
    }


// INDIETRO      [Si attiva alla pressione del tasto indietro. Riporta alla pagina 1 di scelta delle impostazioni]
//---------
    indietro(): void {
        this.numPag = 1;
        this.isLoadingPag2 = false;
        this.listaScadenzeAuto = [];
        this.isLoadingInsScad = false;
    }


// GESTISCI SELEZIONA TUTTI      [Si attiva al change del checkbox seleziona/deseleziona tutti]
//-------------------------
    gestisciSelezionaTutti(event: boolean){

        //Se il checkbox è stato selezionato...
        if(event){
            //Esegue il seleziona tutti
            this.listaScadenzeAuto = this.listaScadenzeAuto.map(scadenza => {
                scadenza.selezionato = true;
                return scadenza;
            });
        }
        else{
            //...altrimenti esegue il deseleziona tutti
            this.listaScadenzeAuto = this.listaScadenzeAuto.map(scadenza => {
                scadenza.selezionato = false;
                return scadenza;
            });
        }
    }


// INSERISCI TERMINI      [Si attiva alla pressione del tasto INSERISCI. Esegue l'inserimento dei termini selezionati]
//------------------
    inserisciTermini(): void {

        //Disabilita i tasti
        this.isLoadingInsScad = true;

        //Inizializza la lista delle scadenze da inserire
        let listaNewScadenze: Scadenza[] = [];

        //Per ogni scadenza selezionata...
        this.listaScadenzeAuto.forEach(scadenza => {
            if(scadenza.selezionato) {

                //Ottiene l'oggetto motivo scadenza corrispondente all'id termine da inserire
                const motivoScadenza = this.motivoScadenzaOptions.find(motivoScad => {return motivoScad.id === scadenza.codiceTermine});

                //Crea la nuova scadenza da inserire
                let newScadenza = new Scadenza();
                newScadenza.pubblica = true;    //Di default a TRUE
                newScadenza.tipoScadenza = motivoScadenza.tipoScadenza;
                newScadenza.motivo = motivoScadenza;
                newScadenza.priorita = this.prioritaOptions.find(priorita => {return priorita.label === 'MEDIA'}); //Di default a priorità MEDIA
                newScadenza.dataScadenza = scadenza.dataTermine;
                newScadenza.evasa = false;  //Di default a FALSE
                newScadenza.note = 'Scadenza generata automaticamente';

                //Aggiunge la scadenza alla lista scadenze da inserire
                listaNewScadenze.push(newScadenza);
            }
        });

        //Esegue l'inserimento di tutte le scadenze selezionate
        this.eseguiInserimentoListaScadenze(listaNewScadenze, this.idSezioneScadenze);
    }


// ESEGUI INSERIMENTO LISTA SCADENZE     [Inserisce ricorsivamente tutte le scadenze della lista di inserimenti da eseguire]
//----------------------------------
    eseguiInserimentoListaScadenze(listaNewScadenze: Scadenza[], idSezioneScadenze: string): void {

        //Finchè la lista è minore di zero, prende il primo elemento e poi ricorsivamente al termine della chiamata http richiama la funzione passandogli la lista senza l'elemente appena inserito
        if(listaNewScadenze.length > 0) {
            this.operationService.addScadenza(this.urlAddScadenza, listaNewScadenze.shift(), idSezioneScadenze, this.idFascicolo).subscribe(response => this.eseguiInserimentoListaScadenze(listaNewScadenze, response.sezione.id));
        }
        else{
            //Se la lista è 0 non bisogna fare altri inserimenti ma chiudere il dialog  //TODO AGGIORNARE L'OGGETTO ESTERNO CHE CONTIENE L'ID SEZIONE SCADENZE! PERCHE' SENNO' NON SA CHE SI E' CREATO NEL CASO
            //this.operationService.readSezione(this.urlReadSezione, this.idSezioneScadenze).subscribe(response => this.aggiornaListaChiudiDialog(response));
            this.chiudiDialog();
        }
    }


// CHIUDI DIALOG     [Chiude il dialog]
//--------------
    chiudiDialog() {

        //Riabilita i tasti
        this.isLoadingInsScad = false;

        this.viewManager._prossimiAdempimenti.next({param: null, timeOut: true});
        this.onReturn.emit();
    }

}
